
import { React, useState, useEffect } from "react";
import { ThreeDots } from 'react-loader-spinner'
import Switch from "@mui/material/Switch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { getApiHeader } from 'utlis/commonfunctions';
import { toast } from 'react-toastify';
import axios from "axios";









const SERVER_URL = process.env.REACT_APP_API_URL;


function SearchStore({ getStep, getFormData }) {

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [storeData, setStoreData] = useState([])
  const [retailerAddress, setRetailerAddress] = useState("")
  const [company, setCompany] = useState("")
  const [name, setName] = useState("")
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [storeDataTable, setStoreDataTable] = useState(false)
  const [retailerDetails1, setRetailerDetails1] = useState(false);
  const [disable, setDisable] = useState(false)

  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = retailerData.slice(indexOfFirstRow, indexOfLastRow);
  const StoreData = storeData.slice(indexOfFirstRow, indexOfLastRow);

  const [formData, setFormData] = useState(getFormData || {
    sim_number: "",
    bundle_number: "",
    control_number: "",
    box_number: "",
    retailer_code: "",
    sim_base_ids: [],
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",

  });


  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };





  const handleStoreSearch = async (e) => {
    e.preventDefault();

    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter post code or city name");

      return;
    } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      return;
    }
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    setLoading(true)

    try {
      const response = await axios.post(`${SERVER_URL}postpaid/search-retailer-store`, filteredFormData, {
        headers: headers
      });

      if (response.status === 200) {
        setDisable(false)
        setLoading(false)
        if (response.data.data !== null && response.data.data.length > 0) {
          setCurrentPage(1)
          setStoreDataTable(true)


          setStoreData(response.data.data)
          setRetailerData(response.data.data)
        } else {
          setStoreDataTable(false)
          setRetailerAddress("")
          setCompany("")
          setName("")
          setFormData({
            retailer_code: "",
          })

          toast.error("No data found during searching");
        }
      }

    } catch (error) {
      setLoading(false)
      setDisable(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };


  const handleChange = (e) => {
    setDisable(false)
    const { name, value } = e.target;

    if (name === "bundle_number") {
      setFormData({ ...formData, [name]: value });
      if (/^\d{0,20}$/.test(value)) {}
    } else if (name === 'sim_number') {
      if (/^\d{0,20}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };




  const handleClear = () => {
    setFormData({
      sim_number: "",
      bundle_number: "",
      control_number: "",
      box_number: "",
      retailer_code: "",
      sim_base_ids: [],
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
    });
    setStoreDataTable(false)
    setRetailerDetails1(false)
    setSelectedRetailerId(null)

  };


  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(retailerData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };


  useEffect(() => {
    if (selectedRetailerId !== null) {
      handleSubmit();
    }
  }, [selectedRetailerId]);



  const handleAllocateRetailer = (event, retailer_id) => {
    if (event.target.checked) {
      setSelectedRetailerId(retailer_id);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: retailer_id
      }));
    } else {
      setSelectedRetailerId(null);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: ""
      }));
    }
  };






  const handleAllocate = async (e) => {
    e.preventDefault();
    setLoading(true)
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}postpaid/allocate_sim_stock`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setLoading(false)
        const data = response.data.data
        console.log("data", data)
        // toast.success(response?.data?.message);
        const message = response.data.message
        setRetailerDetails1(false)
        setStoreDataTable(false)
        setSelectedRetailerId(null)


        setFormData(prevFormData => ({
          ...prevFormData,
          retailer_code: ""
        }));
        swal({
          title: "",
          text: message,
          icon: "success",
          button: "Close"
        });
      }
      getStep(1)

    } catch (error) {
      console.log(error)
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      swal({
        title: "",
        text: errorMessage,
        icon: "error",
        button: "Close"
      });
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
          });
        });

      } else {


      }
    }
  };


  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    setLoading(true)
    try {
      const response = await axios.post(`${SERVER_URL}postpaid/get_retailer_details`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setLoading(false)
        const data = response.data.data
        setRetailerAddress(data.retailer_address)
        setCompany(data.retailer_company_name)
        setName(data.retailer_name)
        setRetailerDetails1(true)
      }

    } catch (error) {
      console.log(error)
      setLoading(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);
      }
    }
  };







  return (
    <>

      <div>
        {loading && (
          <div style={styles.wrapper}>
            <ThreeDots
              visible={loading}
              height="80"
              width="80"
              color="#C11D6C"
              radius="9"
              ariaLabel="three-dots-loading"
            />
          </div>
        )}

        <div className="formbold-main-wrapper">
          <div className="formbold-form-wrapper">
            <h5 style={{ textAlign: "center" }}>Search Store And Allocate  SIM Stock</h5>
            <form action="" method="" onSubmit={handleStoreSearch} autoComplete='off'>
              <div className="formbold-mb-5 formbold-pt-3">
                <label className="formbold-form-label formbold-form-label-2">
                </label>
                <div className="flex flex-wrap formbold--mx-3">
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Store Name
                      </label>
                      <input
                        type="text"
                        name="store_name"
                        id="store_name"
                        placeholder="Enter Store Name"
                        className="formbold-form-input"
                        value={formData.store_name}
                        onChange={handleChange}
                        autoComplete='off'
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Email  Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter Email Address"
                        className="formbold-form-input"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete='off'
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Retailer ID
                      </label>
                      <input
                        type="text"
                        name="retailer_code"
                        id="retailer_code"
                        placeholder="Enter Retailer ID"
                        className="formbold-form-input"
                        value={formData.retailer_code}
                        onChange={handleChange}
                        autoComplete='off'
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        ABN
                      </label>
                      <input
                        type="text"
                        name="abn"
                        id="abn"
                        placeholder="Enter ABN"
                        className="formbold-form-input"
                        value={formData.abn}
                        onChange={handleChange}
                        maxLength={12}
                        autoComplete='off'
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="Enter City Name"
                        className="formbold-form-input"
                        value={formData.city}
                        onChange={handleChange}
                        autoComplete='off'
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Post Code
                      </label>
                      <input
                        type="text"
                        name="postcode"
                        id="postcode"
                        placeholder="Enter Post Code"
                        className="formbold-form-input"
                        value={formData.postcode}
                        onChange={handleChange}
                        autoComplete='off'
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Street Name
                      </label>
                      <input
                        type="text"
                        name="street_name"
                        id="street_name"
                        placeholder="Enter Street Name"
                        className="formbold-form-input"
                        value={formData.street_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="store_name" className="formbold-form-label">
                      State
                    </label>
                    <select
                      className="formbold-form-input"
                      name="state"
                      id="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      <option value="Act">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NIT">NIT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="search-store-buttons">
                <button className="search-store-button" type="submit" disabled={disable}>Search</button>
                {
                  storeDataTable && (
                    <button className="search-store-button" onClick={handleClear}>Clear</button>
                  )
                }
              </div>

            </form>

            {storeDataTable && (
              <div className="container" style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table id="mytable" className="table table-bordred ">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Allocate</th>
                            <th>Retailer ID</th>
                            <th>Retailer Name</th>
                            <th>Store Address</th>
                            <th>Email Address</th>
                          </tr>
                        </thead>
                        <tbody>

                          {StoreData.map((data, index) => (
                            <tr key={indexOfFirstRow + index}>
                              <td>{indexOfFirstRow + index + 1}</td>
                              <td>
                                <input type="checkbox" className="checkthis" checked={selectedRetailerId === data.retailer_code} onChange={(event) => handleAllocateRetailer(event, data.retailer_code)} />
                              </td>
                              <td>{data.retailer_code || "N/A"}</td>
                              <td>{data.retailer_company_name || "N/A"}</td>
                              <td>{data.retailer_store_address || "N/A"}</td>
                              <td>{data.retailer_email || "N/A"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="clearfix" />

                      <div className="pagination">
                        {currentPage > 1 && (
                          <button className="previous" onClick={handlePrevious}>
                            Previous
                          </button>
                        )}
                        {currentPage < Math.ceil(retailerData.length / rowsPerPage) && (
                          <button className="next" onClick={handleNext}>
                            Next
                          </button>
                        )}
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            )}


            {retailerDetails1 && (
              <div classname="formbold-main-wrapper">
                <div classname="formbold-form-wrapper">
                  <div className='trail delar-box'>
                    <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"} >
                      <SoftBox mb={2}>
                        <div className='details'>
                          <h6 className='details-name'>Dealer Name:<span>&nbsp;</span> {name}</h6>
                          <h6 className='details-company'>Company/Store Name: <span>&nbsp;</span>  {company}</h6>
                          <h6 className='details-address'>Dealer Address:<span>&nbsp;</span> {retailerAddress}</h6>
                        </div>
                      </SoftBox>

                      <SoftBox mt={2} mb={2} className="allocate" >
                        <SoftButton variant="gradient" className="allocate-button" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                          Allocate
                        </SoftButton>
                      </SoftBox>
                    </SoftBox>
                  </div>
                </div>
              </div>
            )}
            <button className='handle-back' onClick={() => getStep(1)}> back</button>
          </div>
        </div>
      </div>

    </>
  )
}

export default SearchStore